import {useMutation} from "@tanstack/react-query";

import {addRepresentativeCommissionMutationOptions} from "./add-representative-commission.mutation-options";

export function useAddRepresentativeCommission(representativeId: string) {
  return useMutation(addRepresentativeCommissionMutationOptions(representativeId));
}
